import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  standalone: false,
  selector: 'app-patient-portal-reschedule',
  templateUrl: './patient-portal-reschedule.component.html',
  styleUrls: ['./patient-portal-reschedule.component.css']
})
export class PatientPortalRescheduleComponent implements OnInit {

  reasonText: string;

  constructor(
    public dialogRef: MatDialogRef<PatientPortalRescheduleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {

    console.log(this.data);

  }

  close(proceed) {
    if (!proceed)
      this.reasonText = '';
    this.dialogRef.close(this.reasonText);
  }

}
